import { Box, LoadingOverlay, SegmentedControl } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import { useState } from 'react';
import {
  type Granularity,
  useLoadRemindersAndCollections,
} from 'shared/hooks/use-load-reminders-and-collections';

import { AnalyticsCard } from '../AnalyticsCard';
import { RemindersAndCollectionsChart } from '../charts/RemindersAndCollectionsChart';

const LABELS = i18nKeys.ANALYTICS.REMINDERS_AND_COLLECTIONS;

const NOTHING_YET = { periods: [] };

export const RemindersAndCollectionsCard = () => {
  const { t } = useTranslation();
  const [granularity, setGranularity] = useState<Granularity>('week');
  const { remindersAndCollections = NOTHING_YET, isRemindersAndCollectionsLoading } =
    useLoadRemindersAndCollections({ granularity });

  return (
    <AnalyticsCard
      title={t(LABELS.TITLE)}
      actions={
        <SegmentedControl
          value={granularity}
          onChange={value => setGranularity(value === 'month' ? 'month' : 'week')}
          size="xs"
          data={[
            { label: t(LABELS.GRANULARITY.WEEK), value: 'week' },
            { label: t(LABELS.GRANULARITY.MONTH), value: 'month' },
          ]}
        />
      }
    >
      <Box w="100%" h="400px">
        {isRemindersAndCollectionsLoading ? (
          <LoadingOverlay visible />
        ) : (
          <RemindersAndCollectionsChart {...remindersAndCollections} granularity={granularity} />
        )}
      </Box>
    </AnalyticsCard>
  );
};
